<div class="modal-header">
    <span>Il medico di famiglia è:</span>
    <button
        class="close"
        aria-label="Close"
        (click)="closeModal(false)"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    {{ desc_medico_famiglia.denominazione_medico }}, codice fiscale {{ desc_medico_famiglia.cf_medico }}

    <div *ngIf="autorizzazione?.status == 'authorized'">
        <span> Già concesso l'autorizzazione ai dati sanitari</span>


        <div class="mt-2">
            <button
                nbButton
                outline
                status="danger"
                (click)="closeModal(false)"
            >OK</button>
        </div>
    </div>

    <div *ngIf="can_request && autorizzazione?.status != 'authorized'">
        <span>Vuoi autorizzarlo? </span>

        <div class="mt-2">
            <button
                class="m-2"
                nbButton
                status="primary"
                (click)="autorizza()"
            >OK</button>
            <button
                class="m-2"
                nbButton
                outline
                status="danger"
                (click)="closeModal(false)"
            >Annulla</button>
        </div>
    </div>

</div>
<div class="modal-footer">
    <!-- <button *ngIf="modalCancelEnabled" nbButton status="danger"
  (click)="closeModal(false)">{{modalCancelText}}</button>
  <button nbButton (click)="closeModal(true)">{{modalOkText}}</button> -->
</div>
